import { Button, Form, Result, Spin } from 'antd';

import { Common } from '@app/web-pages';

import { useEditNodeSupplierContract, useGetNodeSupplierContract } from '../data';
import { NodeSupplierContractFormData, useNodeSupplierContractForm } from '../libs/use-node-supplier-contract-form';

export type EditFormProps = {
  onCancel?: () => void;
  id?: number;
};

export const EditForm = (props: EditFormProps) => {
  const { data, isError, isFetching, isPending } = useGetNodeSupplierContract(props.id, {
    enabled: !!props.id,
    staleTime: Infinity,
  });

  const edit = useEditNodeSupplierContract(props.id);
  const { getFormProps, getSuccessResultProps } = useNodeSupplierContractForm(edit, props.onCancel);

  const initialValues: NodeSupplierContractFormData = {
    supplierName: data?.supplierName,
    supplierOption: data?.supplier
      ? {
          label: `${data.supplier.externalId} | ${data.supplier.name}`,
          value: `${data.supplier.externalId}`,
        }
      : undefined,
    node: data?.node
      ? {
          label: data.node.name,
          value: data.node.id,
        }
      : undefined,
    contractName: data?.contractName ?? '',
    contractNumber: data?.contractNumber ?? '',
    intelSignedDate: data?.intelSignedDate ? new Date(data.intelSignedDate) : new Date(),
  };

  return isError || !data ? (
    <Common.NotFoundPage subTitle="Sorry, this node-supplier contract does not exist or was deleted." />
  ) : isFetching || isPending ? (
    <Spin style={{ width: '100%' }} />
  ) : edit.isSuccess ? (
    <Result
      {...getSuccessResultProps({
        extra: [<Button onClick={props.onCancel} children="Ok" type="primary" />],
      })}
      title="Successfully created a node supplier contract!"
    />
  ) : (
    <Form {...getFormProps('edit', initialValues)} />
  );
};
